import { SortOrder } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/sort.pb';
import { useListGroupedBookableAppointmentTypesQuery } from '../queries';
import { useGetSchedulerV3FeatureFlagDetails } from './use-get-scheduler-v3-feature-flag-details';

export type ServiceTypePageConfig = {
  page: number;
  limit: number;
  searchValue?: string;
  sortBy?: 'display_name';
  sortDir?: SortOrder;
};

type UseGetServiceTypesV3DataParamsType = {
  debouncedSearchValue?: string;
  selectedLocationId: string;
  pageConfig?: ServiceTypePageConfig;
  sourceTenantIds?: string[];
  isEnabled?: boolean;
  isIntegratedOffice?: boolean;
  limit?: number;
};

export const useGetServiceTypesV3Data = ({
  selectedLocationId,
  debouncedSearchValue,
  sourceTenantIds,
  pageConfig,
  isEnabled = true,
  isIntegratedOffice: _ = false,
}: UseGetServiceTypesV3DataParamsType) => {
  const { isScheduleV3FlagEnabled } = useGetSchedulerV3FeatureFlagDetails();
  const sortParam = {
    ...(pageConfig?.sortBy && { sortBy: pageConfig.sortBy }),
    ...(pageConfig?.sortDir && { sortDir: pageConfig.sortDir }),
  };

  return useListGroupedBookableAppointmentTypesQuery({
    request: {
      ...(pageConfig?.limit && { limit: pageConfig?.limit }),
      ...(pageConfig?.page && { page: pageConfig?.page }),
      ...(debouncedSearchValue && { name: debouncedSearchValue }),
      ...(sourceTenantIds?.length && { sourceTenantIds }),
      locationId: selectedLocationId,
      ...(Object.keys(sortParam).length ? { sort: sortParam } : {}),
    },

    options: {
      enabled: !!isEnabled && !!selectedLocationId && isScheduleV3FlagEnabled,
    },
  });
};
